import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=7b6467f4&scoped=true&"
import script from "./OrderDetail.vue?vue&type=script&lang=js&"
export * from "./OrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=7b6467f4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6467f4",
  null
  
)

export default component.exports
import {QList,QExpansionItem,QCard,QCardSection,QTable} from 'quasar'
component.options.components = Object.assign({QList,QExpansionItem,QCard,QCardSection,QTable}, component.options.components || {})
